import { useT } from '@/i18n';

export function useSpecialRequestLabels() {
  const t = useT();
  const occasion: Record<string, string> = t.reservations.occasion;
  const seating: Record<string, string> = t.reservations.seating;
  return {
    occasionLabel: (v: string): string => occasion[v] ?? v,
    seatingLabel: (v: string): string => seating[v] ?? v,
  };
}
